import {
  GET_NOTIFICATION_STREAMS,
  GET_NOTIFICATION_STREAMS_START,
  GET_NOTIFICATION_STREAMS_SUCCESS,
  GET_NOTIFICATION_STREAMS_FAIL,
  SET_NOTIFICATION_STREAMS,
  SET_NOTIFICATION_STREAMS_FAIL,
  SET_ACTIVE_NOTIFICATION_STREAMS_FILTERS,
  FILTER_NOTIFICATION_STREAMS,
  RESET_FILTERS,
} from 'actions/eventDetails/filters';
import {
  targetedRecipients,
  TARGETED_RECIPIENTS,
} from '@xmatters/common/constants/notificationStreams';

const initialState = {
  matchingNotificationStreamsCount: 0,
  notificationStreams: [],
  activeItems: [],
  filteredItems: [],
};

export default function filters(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_NOTIFICATION_STREAMS:
    case GET_NOTIFICATION_STREAMS_START: {
      return {
        ...state,
        notificationStreams: payload,
        error: false,
        loading: true,
      };
    }
    case GET_NOTIFICATION_STREAMS_SUCCESS: {
      return {
        ...state,
        notificationStreams: {
          ...payload,
          data: [targetedRecipients, ...payload.data],
        },
        activeItems: [
          targetedRecipients,
          ...payload.data.filter(subscription => !subscription.oneWay),
        ],
        filteredItems: [
          TARGETED_RECIPIENTS,
          ...payload.data
            .filter(subscription => !subscription.oneWay)
            .map(subscription => subscription.id),
        ],
        error: false,
        loading: false,
      };
    }
    case GET_NOTIFICATION_STREAMS_FAIL: {
      return {
        ...state,
        notificationStreams: {},
        error: payload.json,
        loading: false,
      };
    }
    case SET_NOTIFICATION_STREAMS: {
      return {
        ...state,
        notificationStreams: {
          ...payload,
          data: [targetedRecipients, ...payload.data],
        },
        activeItems: [
          targetedRecipients,
          ...payload.data.filter(subscription => !subscription.oneWay),
        ],
        filteredItems: [
          TARGETED_RECIPIENTS,
          ...payload.data
            .filter(subscription => !subscription.oneWay)
            .map(subscription => subscription.id),
        ],
        error: false,
        loading: false,
      };
    }
    case SET_NOTIFICATION_STREAMS_FAIL: {
      return {
        ...state,
        notificationStreams: {},
        error: payload.json,
        loading: false,
      };
    }
    case SET_ACTIVE_NOTIFICATION_STREAMS_FILTERS: {
      const activeItems = [
        ...state.activeItems,
        ...payload.filter(
          item => !state.activeItems.find(a => a.id === item.id),
        ),
      ];

      return {
        ...state,
        activeItems,
      };
    }
    case FILTER_NOTIFICATION_STREAMS: {
      return {
        ...state,
        filteredItems: payload,
      };
    }
    case RESET_FILTERS: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
}
